import React from 'react'

export default function BreakdownSkillBar({nodeLevel, name, percent}) {
  let cat = 'skill-item sub-skill'
  if (nodeLevel == 1) {
    cat = 'skill-item'
  } 

  let component = (
    <div className={cat}>
      <h6 className="title">{name}</h6>
      <div className="bar-graph">
        <span className="score-percent">
          {`${percent}%`}
        </span>
        <div className="score-graph-container">
          <span className="score-graph" style={{width: `${percent}%`}}></span>
        </div>
      </div>
    </div>
  )

  if (nodeLevel == 1) {
    component = (
      <div className='skill-category'>
        {component}
      </div>
    )
  } else if (nodeLevel == 3) {
    component = (
      <li>
        <span className='tree-friend'></span>
        {component}
      </li>
    )
  }
  return (
    component
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/BreakdownSkillBar.js